<template>
  <div class="licence-count">
    <h5>{{ $t("message.add-licenses") }}</h5>
    <div class="box">
      <input
        type="number"
        :min="min"
        :max="max"
        :value="value"
        @change="$emit('change', parseInt($event.target.value))"
      />
      <span>{{ capitalize($t("message.licenses")) }}</span>
      <span class="price"> ${{ unitPrice }} {{ $t("message.per-license") }}</span>
    </div>
    <p class="max-message" v-if="maxMessage" v-html="maxMessage"></p>
  </div>
</template>

<style lang="less" scoped>
.licence-count {
  .box {
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 13px 35px 13px 15px;
    margin-top: 6px;
    display: flex;
    align-items: center;
    input {
      border: 1px solid #444;
      padding: 5px 6px 6px 6px;
      border-radius: 3px;
      background: #f2f2f2;
      margin-right: 7px;
    }
    .price {
      width: 100%;
      text-align: right;
      margin-left: .2em;
    }
  }
}

.max-message {
  margin-top: 0.5em;

  :deep(a) {
    color: rgba(0, 0, 0, 0.5);
    text-decoration: underline;

    &:hover {
      color: rgba(0, 0, 0, 1);
    }
  }
}
</style>

<script>
export default {
  props: {
    value: Number,
    unitPrice: Number,
    min: { type: Number, default: 1 },
    max: Number,
    maxMessage: String,
  },
  mounted: function() {
    this.enforceMinUsers();
  },
  watch: {
    min() {
      this.enforceMinUsers();
    },
    max(max) {
      if (this.max && this.value > this.max) {
        this.$emit("change", this.max);
      }
    }
  },
  methods: {
    enforceMinUsers() {
      if (this.value < this.min) {
        this.$emit("change", this.min);
      }
    },
    capitalize (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  }
};
</script>
